/*表单跳转*/
function FormJump(html){
    const div = document.createElement('div');// 创建div
    div.id = 'formJump';
    div.innerHTML = html; // 将返回的form 放入div
    document.body.appendChild(div);
    document.getElementById('formJump').firstElementChild.submit();
    div.remove();
}
export default FormJump